import React from 'react';
import './Header.css';
import { FiUserPlus, FiUpload } from 'react-icons/fi';
import CommitteeFilter from '../../../Common/CommitteeFilter';

const Header = ({ 
  searchQuery, 
  setSearchQuery, 
  onExport, 
  committees = [], 
  selectedCommittee, 
  setSelectedCommittee 
}) => {

  return (
    <div className="header">
      <div className="header-top">
        <div className="header-title">
          <h1>Team Members</h1>
          <p>Manage and view all team members and their roles</p>
        </div>
        <div className="header-actions">
          <button
            className="btn btn-secondary"
            onClick={onExport}>
            <FiUpload /> Export List
          </button>
          <button
            className="btn btn-primary"
            onClick={() => alert("PM excel file to Issac Goh (@byesaac) on Telegram")}>
            <FiUserPlus /> Add Member
          </button>
        </div>
      </div>
      <div className="header-search">
        <input
          type="text"
          placeholder="Search members by name, role, or house..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />  
        {committees && committees.length > 0 && (
          <CommitteeFilter
            committees={committees}
            value={selectedCommittee}
            onChange={setSelectedCommittee}
          />
        )}
      </div>
    </div>
  );
};

export default Header;
